import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/containers/accordion.containers';
import { YesNoRendererComponent } from '../../../../../common/components/yes-no-renderer.component';

export default function ProgramBasicInfoComponent({
    
    selectedProgram
}: any) {

    return (
        <>
            <AccordionContainer
             
             child={
    <div className="space-y-8">
   
     <div className="p-6 rounded-xl text-center bg-gradient-to-r from-amber-200 via-rose-100 to-orange-200 border border-amber-300 shadow-md">
  <h2 className="text-3xl font-extrabold text-indigo-900">
    {selectedProgram?.Name ?? '-'}
  </h2>

  <p className="mt-3 text-lg text-gray-800">
    {selectedProgram?.Description ?? '-'}
  </p>

  {/* <div className="flex justify-between items-center mt-4">
   <h2 className="text-base text-black text-right flex gap-2 items-center">
      Active: <YesNoRendererComponent value={selectedProgram?.IsActive} />
      Enable: <YesNoRendererComponent value={selectedProgram?.IsEnable} />
    </h2>

   
  </div> */}
</div>

           

   
      
<div className="flex flex-col md:flex-row gap-6">
  <div className="flex-1 p-6 rounded-xl text-center bg-gradient-to-r from-amber-200 via-rose-100 to-orange-200 border border-amber-300 shadow-md">
    <h5 className="text-2xl font-extrabold text-indigo-900">
      {selectedProgram?.Names ?? 'Groups'}
       <p className="mt-3 text-lg text-gray-800">Join a User Group and connect with peers</p>
    </h5>
  </div>

  <div className="flex-1 p-6 rounded-xl text-center bg-gradient-to-r from-amber-200 via-rose-100 to-orange-200 border border-amber-300 shadow-md">
    <h5 className="text-2xl font-extrabold text-indigo-900">
       Events
       <p className="mt-3 text-lg text-gray-800">Explore supporting user events and training</p>
    </h5>
  </div>
</div>


    </div>
}

            />
        </>
    );
}
